import {Navigate, Route, Routes} from "react-router-dom";
import Auth from "./views/auth/index.jsx";
import {PrivateRoute} from "./components/auth/privateRoute.jsx";
import Application from "./views/app/index.jsx";
function App(props) {

  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/app"/>}/>
      <Route path="/app/*" element={<PrivateRoute {...props} />}>
        <Route path="*" index element={<Application {...props} />} />
      </Route>
      <Route path="/auth/*" element={<Auth {...props} />}/>
      <Route path={'*'} element={<Navigate to={'./'}/>}/>
    </Routes>
  )
}

export default App
